// src/js/reducers/index.js
import * as types from "../constants/action-types";
import Sorter from '../utils/sorter';


export default function userReducer(state = [], action) {
    switch (action.type) {
        case types.LOGOUT:
            return []
        case types.CREATE_USER_SUCCESS:

            var users = [...state, Object.assign({}, action.user)];
            return Sorter.sort(users, 'userName');

        case types.UPDATE_USER_SUCCESS:
            var users =[...state.filter(user => user.id !== action.user.id), Object.assign({}, action.user)];
           
            return Sorter.sort(users, 'userName');

        case types.GET_USER_SUCCESS:
            var users =[...state.filter(user => user.id !== action.user.id), Object.assign({}, action.user)];
        
            return Sorter.sort(users, 'userName');

        case types.LOAD_USER_SUCCESS:
        
            return  Sorter.sort(action.items, 'userName');
        

        case types.REMOVE_USER_SUCCESS:
            var result = state.filter(user => user.id !== action.item);
            return Sorter.sort(result,'userName');

        default:
            return state;
    };
};


